import api from './index'
import type { ApiResponse, User } from '@/types'

export const loginWithEmail = async (credentials: {
  email: string
  password: string
}): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await api.post('/auth/login', credentials)
  return response.data
}

export const loginWithGoogle = async (code: string): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await api.post('/auth/google', { code })
  return response.data
}

export const loginWithLine = async (code: string): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await api.post('/auth/line', { code })
  return response.data
}

export const logout = async (): Promise<ApiResponse> => {
  const response = await api.post('/auth/logout')
  return response.data
}

export const getCurrentUser = async (): Promise<ApiResponse<{ user: User }>> => {
  const response = await api.get('/auth/me')
  return response.data
}

export const register = async (userData: {
  email: string
  password: string
  name: string
}): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await api.post('/auth/register', userData)
  return response.data
}

export const login = async (credentials: {
  email: string
  password: string
}): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await api.post('/auth/login', credentials)
  return response.data
}

export const updateProfile = async (updateData: {
  name?: string
  email?: string
  currentPassword?: string
  newPassword?: string
}): Promise<ApiResponse<{ user: User }>> => {
  const response = await api.put('/auth/profile', updateData)
  return response.data
}